import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Login.css";

export default function Login() {
  const { user, loading, sendLink } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && user) navigate("/tests", { replace: true });
  }, [user, loading, navigate]);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await sendLink(email);
      setSent(true);
    } catch (err) {
      console.error(err);
      setError(
        "No pudimos enviar el enlace. Revisa el correo e inténtalo de nuevo.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="login__card card">
        <img className="login__logo" src="/logo-horse.png" alt="Equi for All" />
        {sent ? (
          <>
            <h1 className="login__title">Revisa tu correo</h1>
            <p className="login__text">
              Te hemos enviado un enlace de acceso a <strong>{email}</strong>.
              Ábrelo en este dispositivo para entrar.
            </p>
            <p className="login__hint">
              ¿No lo ves? Revisa tu carpeta de spam o correo no deseado.
            </p>
            <button
              className="btn btn--ghost"
              onClick={() => {
                setSent(false);
                setEmail("");
              }}
            >
              Usar otro correo
            </button>
          </>
        ) : (
          <>
            <h1 className="login__title">¡Hola!</h1>
            <p className="login__text">
              Introduce tu correo y te enviaremos un enlace para acceder a tus
              tests.
            </p>
            <form onSubmit={onSubmit} className="login__form">
              <input
                className="login__input"
                type="email"
                inputMode="email"
                autoComplete="email"
                placeholder="tu@correo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button className="btn btn--block" disabled={busy} type="submit">
                {busy ? "Enviando…" : "Enviar enlace de acceso"}
              </button>
            </form>
            {error && <p className="login__error">{error}</p>}
          </>
        )}
      </div>
    </div>
  );
}
